// Mirrors the backend Domain\Cancellation\Models\CancellationRequest fillable
// (verbonden repo). Keep these keys in sync with that model.
export interface ICancellation {
  id: number;
  name: string;
  email: string;
  company_name: string;
  customer_number: string;
  desired_end_date: string;
  reason: string;
  reason_category: string;
  improvement_suggestion: string;
  terms_accepted: boolean;
  created_at: string;
}

export const defaultCancellation: ICancellation = {
  id: 0,
  name: '',
  email: '',
  company_name: '',
  customer_number: '',
  desired_end_date: '',
  reason: '',
  reason_category: '',
  improvement_suggestion: '',
  terms_accepted: false,
  created_at: '',
};
